import React, { Fragment, useState } from 'react';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import PropTypes from 'prop-types';
import ReviewItem from './ReviewItem';
import ReviewCarousel from '../../../containers/Review/components/ReviewCarousel';

const ReviewGallery = ({
  type,
  items,
}) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [downloadPopupOpened, setDownloadPopupOpened] = useState(false);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const onPlayItem = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const openDownloadPopup = (index) => {
    setDownloadPopupOpened(true);
  };

  const closeDownloadPopup = () => {
    setDownloadPopupOpened(false);
  };



  if (items.length > 0) {
    return (
      <Fragment>
        <div className="review-gallery-type"><span>{type}</span></div>
        <div className="review-items">
          {items.map((item, index) => (
            <ReviewItem
              item={item}
              type={type}
              onPlay={() => onPlayItem(index)}
              onDownload={() => openDownloadPopup(index)}
            />
          ))}
        </div>
        <Modal
          isOpen={viewerIsOpen}
          centered
          className="modal-full-screen"
        >
          <ReviewCarousel items={items} selectedItem={currentImage} onClose={closeLightbox} />
        </Modal>
      </Fragment>
    );
  }

  return null;
};

ReviewGallery.propTypes = {
  type: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    src: PropTypes.string,
    thumb: PropTypes.string,
    type: PropTypes.string,
    category: PropTypes.string,
  })).isRequired,
};

export default ReviewGallery;
